import { render, staticRenderFns } from "./DetailsRating.vue?vue&type=template&id=253334f2&scoped=true&"
import script from "./DetailsRating.vue?vue&type=script&lang=js&"
export * from "./DetailsRating.vue?vue&type=script&lang=js&"
import style0 from "./DetailsRating.vue?vue&type=style&index=0&id=253334f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253334f2",
  null
  
)

export default component.exports